import { openBlock as t, createElementBlock as o, renderSlot as r } from "vue";
import { _ as a } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/Catalog.css';const c = {}, n = { class: "catalog" };
function s(e, d) {
  return t(), o("div", n, [
    r(e.$slots, "default", {}, void 0, !0)
  ]);
}
const f = /* @__PURE__ */ a(c, [["render", s], ["__scopeId", "data-v-19a9383d"]]);
export {
  f as default
};
